import { render, staticRenderFns } from "./AuthContainer.vue?vue&type=template&id=8cb0c8ae&"
import script from "./AuthContainer.vue?vue&type=script&lang=ts&"
export * from "./AuthContainer.vue?vue&type=script&lang=ts&"
import style0 from "./AuthContainer.vue?vue&type=style&index=0&id=8cb0c8ae&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports